import { type FC } from 'react';

import { Tag } from '@wk/components-react16';

import type { OnboardingExceptionApprovalStatus } from '@/features/onboarding/types/onboarding.types';

interface OnboardingExceptionApprovalTagProps {
  approvalStatus: OnboardingExceptionApprovalStatus;
}

const OnboardingExceptionApprovalTag: FC<
  OnboardingExceptionApprovalTagProps
> = ({ approvalStatus }) => {
  if (!approvalStatus) {
    return null;
  }

  if (approvalStatus === 'pending') {
    return <Tag color="blue">Exception Pending Approval</Tag>;
  }

  if (approvalStatus === 'approved') {
    return <Tag color="green">Exception Approved</Tag>;
  }

  return <Tag color="red">Exception Rejected</Tag>;
};

export default OnboardingExceptionApprovalTag;
